
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/government-success",
      function () {
        return require("private-next-pages/get-started/government-success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/government-success"])
      });
    }
  